import { render } from "./MyButton.vue?vue&type=template&id=2c9e1838&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"

import "./MyButton.vue?vue&type=style&index=0&id=2c9e1838&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c9e1838"

export default script